import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "imperio_token";

const authHeaders = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getMarketPairs = async () => {
  const res = await axios.get(`${API}/markets/pairs`);
  return res.data.pairs || [];
};
export const getFavorites = async () => (await axios.get(`${API}/user/favorites`, { headers: authHeaders() })).data.favorites || [];
export const saveFavorites = async (favorites) => (await axios.put(`${API}/user/favorites`, { favorites }, { headers: authHeaders() })).data.favorites;
export const getMarketPrices = async (includeUnpriced = false) => {
  const res = await axios.get(`${API}/markets/prices`, { params: includeUnpriced ? { include_unpriced: true } : {} });
  return res.data.assets;
};

export const getPortfolio = async () => {
  const res = await axios.get(`${API}/portfolio`, { headers: authHeaders() });
  return res.data;
};

export const getPortfolioHistory = async () => {
  const res = await axios.get(`${API}/portfolio/history`, { headers: authHeaders() });
  return res.data;
};

export const getWithdrawInfo = async (asset, network) => {
  const res = await axios.get(`${API}/wallet/withdraw-info`, { params: { asset, network: network || undefined }, headers: authHeaders() });
  return res.data;
};


export const postTransaction = async (type, asset, amount, address = null, network = null, totp = null, email_otp = null) => {
  const res = await axios.post(
    `${API}/portfolio/transaction`,
    { type, asset, amount, address, network, totp, email_otp },
    { headers: authHeaders() }
  );
  return res.data;
};

export const requestWithdrawOtp = async () =>
  (await axios.post(`${API}/wallet/withdraw/request-otp`, {}, { headers: authHeaders() })).data;

export const postTransfer = async (asset, amount, from_account, to_account) => {
  const res = await axios.post(
    `${API}/transfer`,
    { asset, amount, from_account, to_account },
    { headers: authHeaders() }
  );
  return res.data;
};

export const getReferral = async () => {
  const res = await axios.get(`${API}/referral`, { headers: authHeaders() });
  return res.data;
};

export const bindReferral = async (code) => {
  const res = await axios.post(`${API}/referral/bind`, { code }, { headers: authHeaders() });
  return res.data;
};

export const redeemReferral = async () => (await axios.post(`${API}/referral/redeem`, {}, { headers: authHeaders() })).data;
export const getFeeWallet = async () => (await axios.get(`${API}/admin/fee-wallet`, { headers: authHeaders() })).data;
export const transferFeeWallet = async (body) => (await axios.post(`${API}/admin/fee-wallet/transfer`, body, { headers: authHeaders() })).data;

export const getReferralRewards = async () => {
  const res = await axios.get(`${API}/referral/rewards`, { headers: authHeaders() });
  return res.data;
};

export const getRewardsHub = async () => (await axios.get(`${API}/rewards/hub`, { headers: authHeaders() })).data;
export const claimRewardTask = async (task) => (await axios.post(`${API}/rewards/claim-task`, { task }, { headers: authHeaders() })).data;
export const redeemReward = async (cost, reward) => (await axios.post(`${API}/rewards/redeem`, { cost, reward }, { headers: authHeaders() })).data;

export const getEarn = async () => {
  const res = await axios.get(`${API}/earn`, { headers: authHeaders() });
  return res.data;
};
export const earnSubscribe = async (asset, amount) => {
  const res = await axios.post(`${API}/earn/subscribe`, { asset, amount }, { headers: authHeaders() });
  return res.data;
};
export const earnRedeem = async (asset, amount) => {
  const res = await axios.post(`${API}/earn/redeem`, { asset, amount }, { headers: authHeaders() });
  return res.data;
};

export const convertQuote = async (from_asset, to_asset, amount) => {
  const res = await axios.post(`${API}/convert/quote`, { from_asset, to_asset, amount }, { headers: authHeaders() });
  return res.data;
};
export const convertExecute = async (from_asset, to_asset, amount) => {
  const res = await axios.post(`${API}/convert/execute`, { from_asset, to_asset, amount }, { headers: authHeaders() });
  return res.data;
};
export const convertDust = async () => (await axios.post(`${API}/convert/dust`, {}, { headers: authHeaders() })).data;
export const convertDustPreview = async () => (await axios.get(`${API}/convert/dust/preview`, { headers: authHeaders() })).data;
export const getConvertHistory = async () => (await axios.get(`${API}/convert/history`, { headers: authHeaders() })).data;

// --- Security: 2FA (TOTP) + password ---
export const start2FA = async () => (await axios.post(`${API}/auth/2fa/enrol`, {}, { headers: authHeaders() })).data;
export const verify2FA = async (code) => (await axios.post(`${API}/auth/2fa/verify`, { code }, { headers: authHeaders() })).data;
export const disable2FA = async (code) => (await axios.post(`${API}/auth/2fa/disable`, { code }, { headers: authHeaders() })).data;
export const recoveryStatus = async () => (await axios.get(`${API}/auth/2fa/recovery/status`, { headers: authHeaders() })).data;
export const regenerateRecovery = async (code) => (await axios.post(`${API}/auth/2fa/recovery/regenerate`, { code }, { headers: authHeaders() })).data;
export const changePassword = async (current_password, new_password) => (await axios.post(`${API}/auth/change-password`, { current_password, new_password }, { headers: authHeaders() })).data;
export const requestSetPasswordOtp = async () => (await axios.post(`${API}/auth/set-password/request-otp`, {}, { headers: authHeaders() })).data;
export const setPassword = async (code, new_password) => (await axios.post(`${API}/auth/set-password`, { code, new_password }, { headers: authHeaders() })).data;

// --- Security center ---
export const getSecurityOverview = async () => (await axios.get(`${API}/security/overview`, { headers: authHeaders() })).data;
export const setAntiPhishing = async (code) => (await axios.post(`${API}/security/anti-phishing`, { code }, { headers: authHeaders() })).data;
export const setEmergencyContact = async (payload) => (await axios.post(`${API}/security/emergency-contact`, payload, { headers: authHeaders() })).data;
export const phoneStart = async (number) => (await axios.post(`${API}/security/phone/start`, { number }, { headers: authHeaders() })).data;
export const phoneVerify = async (code) => (await axios.post(`${API}/security/phone/verify`, { code }, { headers: authHeaders() })).data;
export const phoneRemove = async () => (await axios.post(`${API}/security/phone/remove`, {}, { headers: authHeaders() })).data;
export const setWithdrawProtection = async (whitelist_only) => (await axios.post(`${API}/security/withdraw-protection`, { whitelist_only }, { headers: authHeaders() })).data;
export const addWhitelist = async (payload) => (await axios.post(`${API}/security/whitelist`, payload, { headers: authHeaders() })).data;
export const getImrioPage = async () => (await axios.get(`${API}/imrio-page`)).data;
export const saveImrioPage = async (data) => (await axios.put(`${API}/admin/imrio-page`, data, { headers: authHeaders() })).data;
export const getSecurityHealth = async () => (await axios.get(`${API}/security/health`, { headers: authHeaders() })).data;
export const getAddressAlert = async (t) => (await axios.get(`${API}/security/address-alert/${encodeURIComponent(t)}`)).data;
export const lockAddressAlert = async (t) => (await axios.post(`${API}/security/address-alert/${encodeURIComponent(t)}/lock`)).data;
export const getWhitelist = async () => (await axios.get(`${API}/security/whitelist`, { headers: authHeaders() })).data;
export const requestWhitelistOtp = async () => (await axios.post(`${API}/security/whitelist/request-otp`, {}, { headers: authHeaders() })).data;
export const renameWhitelist = async (id, label) => (await axios.patch(`${API}/security/whitelist/${id}`, { label }, { headers: authHeaders() })).data;
export const getFeeRevenue = async (params) => (await axios.get(`${API}/admin/fee-revenue`, { params, headers: authHeaders() })).data;
export const removeWhitelist = async (id) => (await axios.delete(`${API}/security/whitelist/${id}`, { headers: authHeaders() })).data;
export const getSecurityActivity = async () => (await axios.get(`${API}/security/activity`, { headers: authHeaders() })).data;
export const disableAccount = async () => (await axios.post(`${API}/security/disable-account`, {}, { headers: authHeaders() })).data;
export const passkeyBegin = async (ctx) => (await axios.post(`${API}/passkeys/register/begin`, ctx || {}, { headers: authHeaders() })).data;
export const passkeyComplete = async (credential, name, ctx) => (await axios.post(`${API}/passkeys/register/complete`, { credential, name, ...(ctx || {}) }, { headers: authHeaders() })).data;
export const listPasskeys = async () => (await axios.get(`${API}/passkeys`, { headers: authHeaders() })).data;
export const deletePasskey = async (id) => (await axios.delete(`${API}/passkeys/${id}`, { headers: authHeaders() })).data;

// --- Site footer (admin-editable) ---
export const getFooter = async (raw = false) => (await axios.get(`${API}/footer`, { params: raw ? { raw: true } : {} })).data;
export const listAdminPages = async () => (await axios.get(`${API}/admin/pages`, { headers: authHeaders() })).data;
export const saveAdminPage = async (data) => (await axios.post(`${API}/admin/pages`, data, { headers: authHeaders() })).data;
export const deleteAdminPage = async (id) => (await axios.delete(`${API}/admin/pages/${id}`, { headers: authHeaders() })).data;
export const getPublicPage = async (slug) => (await axios.get(`${API}/pages/${slug}`)).data;
export const listAdminPopups = async () => (await axios.get(`${API}/admin/popups`, { headers: authHeaders() })).data;
export const saveAdminPopup = async (id, body) => (await (id ? axios.put(`${API}/admin/popups/${id}`, body, { headers: authHeaders() }) : axios.post(`${API}/admin/popups`, body, { headers: authHeaders() }))).data;
export const deleteAdminPopup = async (id) => (await axios.delete(`${API}/admin/popups/${id}`, { headers: authHeaders() })).data;
export const getActivePopups = async () => (await axios.get(`${API}/popups/active`, { headers: authHeaders() })).data;
export const dismissPopup = async (id) => (await axios.post(`${API}/popups/${id}/dismiss`, {}, { headers: authHeaders() })).data;
export const getOgImages = async () => (await axios.get(`${API}/admin/og-images`, { headers: authHeaders() })).data;
export const saveOgImages = async (body) => (await axios.put(`${API}/admin/og-images`, body, { headers: authHeaders() })).data;
export const getUserLogs = async (params) => (await axios.get(`${API}/admin/user-logs`, { params, headers: authHeaders() })).data;
export const getFuturesOrderBook = async (symbol) => (await axios.get(`${API}/futures/orderbook`, { params: { symbol } })).data;
export const getFuturesMarkets = async () => (await axios.get(`${API}/futures/markets`)).data;
export const getFuturesAccount = async () => (await axios.get(`${API}/futures/account`, { headers: authHeaders() })).data;
export const placeFuturesOrder = async (body) => (await axios.post(`${API}/futures/order`, body, { headers: authHeaders() })).data;
export const cancelFuturesOrder = async (id) => (await axios.delete(`${API}/futures/order/${id}`, { headers: authHeaders() })).data;
export const closeFuturesPosition = async (id, qty = null) => (await axios.post(`${API}/futures/position/${id}/close`, { qty }, { headers: authHeaders() })).data;
export const setFuturesTpSl = async (id, tp, sl) => (await axios.patch(`${API}/futures/position/${id}/tpsl`, { tp, sl }, { headers: authHeaders() })).data;
export const futuresTransfer = async (direction, amount) => (await axios.post(`${API}/futures/transfer`, { direction, amount }, { headers: authHeaders() })).data;
export const getFuturesPnl = async (days) => (await axios.get(`${API}/futures/pnl`, { params: { days }, headers: authHeaders() })).data;
export const getFuturesFunding = async (symbol) => (await axios.get(`${API}/futures/funding`, { params: { symbol }, headers: authHeaders() })).data;
export const getFuturesHistory = async () => (await axios.get(`${API}/futures/history`, { headers: authHeaders() })).data;
export const getAdminFutures = async () => (await axios.get(`${API}/admin/futures`, { headers: authHeaders() })).data;
export const saveAdminFutures = async (sym, body) => (await axios.put(`${API}/admin/futures/${sym}`, body, { headers: authHeaders() })).data;
export const listMedia = async (q = "") => (await axios.get(`${API}/admin/media`, { params: { q }, headers: authHeaders() })).data;
export const deleteMedia = async (id) => (await axios.delete(`${API}/admin/media/${id}`, { headers: authHeaders() })).data;
export const listAdminBlog = async () => (await axios.get(`${API}/admin/blog`, { headers: authHeaders() })).data;
export const saveAdminBlog = async (data) => (await axios.post(`${API}/admin/blog`, data, { headers: authHeaders() })).data;
export const deleteAdminBlog = async (id) => (await axios.delete(`${API}/admin/blog/${id}`, { headers: authHeaders() })).data;
export const uploadBlogCover = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return (await axios.post(`${API}/admin/blog/cover`, fd, { headers: authHeaders() })).data;
};
export const getBlogPosts = async (params = {}) => (await axios.get(`${API}/blog`, { params })).data;
export const getBlogPost = async (slug) => (await axios.get(`${API}/blog/${slug}`)).data;
export const updateFooter = async (data) => (await axios.put(`${API}/admin/footer`, data, { headers: authHeaders() })).data;

// --- Support tickets (user-facing) ---
export const createSupportTicket = async (payload) => (await axios.post(`${API}/support/ticket`, payload, { headers: authHeaders() })).data;
export const getMySupportTickets = async () => (await axios.get(`${API}/support/tickets`, { headers: authHeaders() })).data;
export const replyMyTicket = (ticketId, body) => adminPost(`/support/tickets/${ticketId}/reply`, { body });
export const markTicketRead = (ticketId) => adminPost(`/support/tickets/${ticketId}/read`, {});
export const getUnreadTicketCount = () => adminGet("/support/tickets/unread-count");

// Admin desks
export const adminGetEarn = () => adminGet("/admin/earn");
export const adminSetEarnApy = (payload) => adminPost("/admin/earn/apy", payload);
export const adminSetEarnDefault = (payload) => adminPost("/admin/earn/default", payload);
export const adminGetConvert = () => adminGet("/admin/convert");
export const adminSetConvert = (payload) => adminPost("/admin/convert", payload);
export const adminGetReferral = () => adminGet("/admin/referral");
export const adminSetReferral = (payload) => adminPost("/admin/referral", payload);
export const adminSetReferralConfig = (payload) => adminPost("/admin/referral-config", payload);
export const adminGetNotificationConfig = () => adminGet("/admin/notification-config");
export const adminSetNotificationConfig = (payload) => adminPost("/admin/notification-config", payload);

export const postTrade = async (side, asset, quantity, quote = "USDT", account_id = null, bracket = {}) => {
  const res = await axios.post(
    `${API}/trade`,
    { side, asset, quantity, quote, account_id: account_id && account_id !== "main" ? account_id : null, ...bracket },
    { headers: authHeaders() }
  );
  return res.data;
};

export const getChart = async (symbol) => {
  const res = await axios.get(`${API}/markets/chart`, { params: { symbol } });
  return res.data.points;
};

export const getOHLC = async (symbol, interval, quote = "USDT") => {
  const res = await axios.get(`${API}/markets/ohlc`, { params: { symbol, interval, quote } });
  const c = res.data.candles || [];
  c.source = res.data.source;  // "binance" = identical Binance chart, "exchange" = own trade tape
  return c;
};

export const getOrders = async (account = null) => {
  const res = await axios.get(`${API}/orders`, { headers: authHeaders(), params: account && account !== "main" ? { account } : {} });
  return res.data;
};

export const getOrderFills = async (orderId, account = null) => {
  const res = await axios.get(`${API}/orders/${orderId}/fills`, { headers: authHeaders(), params: account && account !== "main" ? { account } : {} });
  return res.data;
};


export const getOrderTrades = async (account = null) => {
  const res = await axios.get(`${API}/orders/trades`, { headers: authHeaders(), params: account && account !== "main" ? { account } : {} });
  return res.data;
};

export const postOrder = async (side, asset, limit_price, quantity, stop_price = null, quote = "USDT", opts = {}) => {
  const res = await axios.post(
    `${API}/orders`,
    { side, asset, limit_price, quantity, stop_price, quote, order_type: opts.order_type || "limit", reduce_only: !!opts.reduce_only, account_id: opts.account_id || null,
      ...(opts.tp_price ? { tp_price: opts.tp_price } : {}), ...(opts.sl_price ? { sl_price: opts.sl_price } : {}) },
    { headers: authHeaders() }
  );
  return res.data;
};

export const moveOrderPrice = async (orderId, limit_price, account = null) =>
  (await axios.patch(`${API}/orders/${orderId}/price`, { limit_price, account: account && account !== "main" ? account : null }, { headers: authHeaders() })).data;
export const cancelOrder = async (orderId, account = null) => {
  const res = await axios.delete(`${API}/orders/${orderId}`, { headers: authHeaders(), params: account && account !== "main" ? { account } : {} });
  return res.data;
};

export const previewOrder = async (payload) => {
  const res = await axios.post(`${API}/orders/preview`, payload, { headers: authHeaders() });
  return res.data;
};

export const getOrderBook = async (asset, quote = "USDT") => {
  const res = await axios.get(`${API}/orderbook`, { params: { asset, quote } });
  return res.data;
};

export const postOCO = async (side, asset, quantity, limit_price, stop_price, stop_limit_price, quote = "USDT") => {
  const res = await axios.post(
    `${API}/orders/oco`,
    { side, asset, quantity, limit_price, stop_price, stop_limit_price, quote },
    { headers: authHeaders() }
  );
  return res.data;
};

export const getRoutingStatus = async () => {
  const res = await axios.get(`${API}/routing/status`);
  return res.data;
};

export const postGrid = async (payload) => {
  const res = await axios.post(`${API}/orders/grid`, payload, { headers: authHeaders() });
  return res.data;
};

export const getSweepPlan = async () => {
  const res = await axios.get(`${API}/admin/sweep/plan`, { headers: authHeaders() });
  return res.data;
};

export const executeSweep = async (dry_run = true) => {
  const res = await axios.post(`${API}/admin/sweep/execute`, { dry_run }, { headers: authHeaders() });
  return res.data;
};

export const getSweepHistory = async () => {
  const res = await axios.get(`${API}/admin/sweep/history`, { headers: authHeaders() });
  return res.data;
};

export const getAdminOverview = async () => {
  const res = await axios.get(`${API}/admin/overview`, { headers: authHeaders() });
  return res.data;
};

export const getAutoSweep = async () => {
  const res = await axios.get(`${API}/admin/auto-sweep`, { headers: authHeaders() });
  return res.data;
};

export const setAutoSweep = async (payload) => {
  const res = await axios.post(`${API}/admin/auto-sweep`, payload, { headers: authHeaders() });
  return res.data;
};

export const runAutoSweepNow = async () => {
  const res = await axios.post(`${API}/admin/auto-sweep/run-now`, {}, { headers: authHeaders() });
  return res.data;
};

// --- Admin console (37-module back office) ---
const adminGet = async (path) => (await axios.get(`${API}${path}`, { headers: authHeaders() })).data;
const adminPost = async (path, body) => (await axios.post(`${API}${path}`, body, { headers: authHeaders() })).data;
export const getUmmBots = () => adminGet("/admin/umm-bots");
export const createUmmBot = (b) => adminPost("/admin/umm-bots", b);
export const updateUmmBot = async (id, b) => (await axios.patch(`${API}/admin/umm-bots/${id}`, b, { headers: authHeaders() })).data;
export const ummBotAction = (id, action) => adminPost(`/admin/umm-bots/${id}/${action}`);
export const ummBulkUpdate = (patch) => adminPost("/admin/umm-bots-bulk", patch);
export const deleteUmmBot = async (id) => (await axios.delete(`${API}/admin/umm-bots/${id}`, { headers: authHeaders() })).data;
export const getCoralTreasury = () => adminGet("/admin/coral/treasury");
export const sweepCoralNow = () => adminPost("/admin/coral/sweep", {});
export const getAdminMe = () => adminGet("/admin/me");
export const getAdminDashboard = () => adminGet("/admin/dashboard");
export const getAdminCustomers = () => adminGet("/admin/customers");
export const customerAction = (payload) => adminPost("/admin/customers/action", payload);
export const adjustBalance = (payload) => adminPost("/admin/customers/adjust-balance", payload);
export const getAdminKyc = () => adminGet("/admin/kyc");
export const getKycFiles = (userId) => adminGet(`/admin/kyc/${userId}/files`);
export const kycDecision = (payload) => adminPost("/admin/kyc/decision", payload);
export const getAdminAlerts = () => adminGet("/admin/alerts");
export const getAdminAml = () => adminGet("/admin/aml");
export const getProofOfReserves = () => adminGet("/admin/proof-of-reserves");
export const getTravelRule = () => adminGet("/admin/travel-rule");
export const getAdminLiquidity = () => adminGet("/admin/liquidity");
export const getAdminFinance = () => adminGet("/admin/finance");
export const getAdminWithdrawals = () => adminGet("/admin/withdrawals");
export const getAdminTrading = () => adminGet("/admin/trading");
export const getAdminMarkets = () => adminGet("/admin/markets");
export const getTradingEngine = () => adminGet("/admin/trading/engine");
export const setTradingEngine = (payload) => adminPost("/admin/trading/engine", payload);
export const cancelAllOrders = (payload) => adminPost("/admin/trading/cancel-all", payload);
export const getStaleConfig = () => adminGet("/admin/trading/stale-config");
export const staleCleanNow = (payload) => adminPost("/admin/trading/stale-clean-now", payload);
export const staleAuto = (payload) => adminPost("/admin/trading/stale-auto", payload);
export const pausePair = (payload) => adminPost("/admin/trading/pause-pair", payload);
export const getMarketsConfig = () => adminGet("/admin/markets/config");
export const setMarketConfig = (payload) => adminPost("/admin/markets/config", payload);
export const marketLifecycle = (payload) => adminPost("/admin/markets/lifecycle", payload);
export const createPair = (payload) => adminPost("/admin/markets/create", payload);
export const quickCreatePair = (payload) => adminPost("/admin/markets/quick-create", payload);
export const removePair = (payload) => adminPost("/admin/markets/remove", payload);
export const setMarketPrice = (payload) => adminPost("/admin/markets/set-price", payload);
export const deletePair = (payload) => adminPost("/admin/markets/delete-pair", payload);
export const getMarketTemplates = () => adminGet("/admin/markets/templates");
export const saveMarketTemplate = (payload) => adminPost("/admin/markets/templates", payload);
export const deleteMarketTemplate = async (tid) => {
  const res = await axios.delete(`${API}/admin/markets/templates/${tid}`, { headers: authHeaders() });
  return res.data;
};
export const getMarketNotices = async () => {
  const res = await axios.get(`${API}/markets/notices`);
  return res.data.notices || [];
};
export const getAdminRisk = () => adminGet("/admin/risk");
export const setAdminRisk = (payload) => adminPost("/admin/risk", payload);
export const getAdminTickets = () => adminGet("/admin/tickets");
export const createTicket = (payload) => adminPost("/admin/tickets", payload);
export const setTicketStatus = (payload) => adminPost("/admin/tickets/status", payload);
export const replyTicket = (payload) => adminPost("/admin/tickets/reply", payload);
export const getCannedReplies = () => adminGet("/admin/canned-replies");
export const createCannedReply = (payload) => adminPost("/admin/canned-replies", payload);
export const deleteCannedReply = (payload) => adminPost("/admin/canned-replies/delete", payload);
export const getAdminRoles = () => adminGet("/admin/roles");
export const assignRole = (payload) => adminPost("/admin/roles/assign", payload);
export const createAdmin = (payload) => adminPost("/admin/admins/create", payload);
export const updateAdmin = (payload) => adminPost("/admin/admins/update", payload);
export const adminMgmtAction = (payload) => adminPost("/admin/admins/action", payload);
export const getAdminAudit = () => adminGet("/admin/audit");
export const getAdminSystem = () => adminGet("/admin/system");
export const getAdminTreasury = () => adminGet("/admin/treasury");
export const prefundGas = (payload) => adminPost("/admin/wallet/prefund-gas", payload);
export const getEmergency = () => adminGet("/admin/emergency");
export const setEmergency = (payload) => adminPost("/admin/emergency", payload);
export const getAdminFees = () => adminGet("/admin/fees");
export const setAdminFees = (payload) => adminPost("/admin/fees", payload);
export const setAdminFeeToken = (payload) => adminPost("/admin/fees/token", payload);
export const getUserDetail = (id) => adminGet(`/admin/user/${id}`);
export const getAdminTradeHistory = (qs = "") => adminGet(`/admin/trades/history${qs ? `?${qs}` : ""}`);
export const getSecurityEvents = ({ group = "all", severity = "", q = "", hours = 168 } = {}) =>
  adminGet(`/admin/security-events?${new URLSearchParams({ group, severity, q, hours })}`);
export const securityFreeze = (userId, action, reason = "") => adminPost(`/admin/security/users/${userId}/${action}`, { reason });
export const getIpBans = () => adminGet("/admin/security/ip-bans");
export const banIp = (ip, hours, reason) => adminPost("/admin/security/ip-bans", { ip, hours, reason });
export const unbanIp = async (ip) => (await axios.delete(`${API}/admin/security/ip-bans/${encodeURIComponent(ip)}`, { headers: authHeaders() })).data;
export const saveIpWhitelist = async (ips) => (await axios.put(`${API}/admin/security/ip-whitelist`, { ips }, { headers: authHeaders() })).data;
export const getDisposableDomains = () => adminGet("/admin/security/disposable-domains");
export const saveDisposableDomains = async (extra, allow) =>
  (await axios.put(`${API}/admin/security/disposable-domains`, { extra, allow }, { headers: authHeaders() })).data;
export const getAdminVolumeBreakdown = (hours = 24) => adminGet(`/admin/volume-breakdown?hours=${hours}`);
export const getAdminOnlineUsers = (minutes = 5) => adminGet(`/admin/online-users?minutes=${minutes}`);
export const getUserTradingHistory = (id, qs = "") => adminGet(`/admin/user/${id}/trading-history${qs ? `?${qs}` : ""}`);
export const updateUser = (payload) => adminPost("/admin/user/update", payload);
export const userAction = (payload) => adminPost("/admin/user/action", payload);
export const getPendingWithdrawals = () => adminGet("/admin/withdrawals/pending");
export const claimWithdrawal = (payload) => adminPost("/admin/withdrawals/claim", payload);
export const approveWithdrawal = (payload) => adminPost("/admin/withdrawals/approve", payload);
export const setWithdrawalTx = (payload) => adminPost("/admin/withdrawals/set-tx", payload);
export const rejectWithdrawal = (payload) => adminPost("/admin/withdrawals/reject", payload);
export const getKycMe = () => adminGet("/kyc/me");
export const submitKyc = async (formData, onProgress) => {
  const res = await axios.post(`${API}/kyc/submit`, formData, {
    headers: { ...authHeaders(), "Content-Type": "multipart/form-data" }, timeout: 180000,
    onUploadProgress: (e) => onProgress && e.total && onProgress(Math.round((e.loaded / e.total) * 100)),
  });
  return res.data;
};
export const kycFileUrl = (path) => `${API}/kyc/file/${path}?auth=${localStorage.getItem("imperio_token")}`;
export const getAdminNetworks = () => adminGet("/admin/networks");
export const updateNetwork = (payload) => adminPost("/admin/networks", payload);
export const getNetworkMonitor = () => adminGet("/admin/networks/monitor");
export const getAssetConfigs = () => adminGet("/admin/assets/config");
export const updateAssetConfig = (payload) => adminPost("/admin/assets/config", payload);
export const validateContract = (payload) => adminPost("/admin/assets/validate-contract", payload);
export const listToken = (payload) => adminPost("/admin/assets/list-token", payload);
export const deleteToken = async (symbol) => (await axios.delete(`${API}/admin/assets/token/${encodeURIComponent(symbol)}`, { headers: authHeaders() })).data;
export const uploadAssetLogo = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await axios.post(`${API}/admin/assets/upload-logo`, fd, { headers: { ...authHeaders(), "Content-Type": "multipart/form-data" } });
  return data;
};
export const assetLogoUrl = (path) => (path ? (path.startsWith("http") ? path : `${API}/assets/logo/${path}`) : "");
export const getNotifications = () => adminGet("/notifications");
export const markNotificationsRead = () => adminPost("/notifications/read", {});
export const getSweepPlanAdmin = getSweepPlan;

export const getPnlAnalysis = async (days = 90) => {
  const res = await axios.get(`${API}/account/pnl-analysis`, { headers: authHeaders(), params: { days } });
  return res.data;
};

export const getBalanceHistory = async (days = 7) => {
  const res = await axios.get(`${API}/portfolio/balance-history`, { headers: authHeaders(), params: { days } });
  return res.data;
};

export const getAccountPnl = async () => {
  const res = await axios.get(`${API}/account/pnl`, { headers: authHeaders() });
  return res.data;
};

export const setFeeDiscount = async (enabled) => {
  const res = await axios.post(`${API}/account/fee-discount`, { enabled }, { headers: authHeaders() });
  return res.data;
};

export const getMasterWallet = async () => {
  const res = await axios.get(`${API}/admin/master-wallet`, { headers: authHeaders() });
  return res.data;
};

export const getAdminDeposits = async (email) => {
  const res = await axios.get(`${API}/admin/deposits`, { headers: authHeaders(), params: email ? { email } : {} });
  return res.data.deposits;
};

export const verifyDeposit = async (email, tx_hash) => {
  const res = await axios.post(`${API}/admin/verify-deposit`, { email, tx_hash }, { headers: authHeaders() });
  return res.data;
};

export const getDepositsQueue = () => adminGet("/admin/deposits/queue");
export const depositAction = (payload) => adminPost("/admin/deposits/action", payload);
export const getWithdrawalsQueue = () => adminGet("/admin/withdrawals/queue");
export const manageWithdrawal = (payload) => adminPost("/admin/withdrawals/manage", payload);
export const getLockouts = () => adminGet("/admin/security/lockouts");
export const clearLockout = (payload) => adminPost("/admin/security/lockouts/clear", payload);
export const nudge2FA = () => adminPost("/admin/security/2fa-nudge", {});
export const migrate2FA = () => adminPost("/admin/security/migrate-2fa", {});
// Announcements
export const getActiveAnnouncements = () => adminGet("/announcements/active");
export const getAdminAnnouncements = () => adminGet("/admin/announcements");
export const createAnnouncement = (payload) => adminPost("/admin/announcements", payload);
export const updateAnnouncement = (payload) => adminPost("/admin/announcements/update", payload);
export const announcementEvent = (annId, kind) => adminPost(`/announcements/${annId}/event`, { kind });
export const getAnnouncementTrends = () => adminGet("/admin/announcements/trends");
// API keys
export const createApiKey = (payload) => adminPost("/me/api-keys", payload);
export const listApiKeys = () => adminGet("/me/api-keys");
export const revokeApiKey = (payload) => adminPost("/me/api-keys/revoke", payload);
export const adminListApiKeys = () => adminGet("/admin/api-keys");
export const adminRevokeApiKey = (payload) => adminPost("/admin/api-keys/revoke", payload);
export const adminSuspendApiKey = (payload) => adminPost("/admin/api-keys/suspend", payload);
export const adminUnsuspendApiKey = (payload) => adminPost("/admin/api-keys/unsuspend", payload);

// --- Market AI assistant (ChatGPT) — streams SSE token-by-token ---
export const marketAiHistory = (session_id) => adminGet(`/market-ai/history?session_id=${encodeURIComponent(session_id)}`);

export const transcribeVoice = async (blob) => {
  const fd = new FormData();
  fd.append("audio", blob, "voice.webm");
  const { data } = await axios.post(`${API}/market-ai/transcribe`, fd, {
    headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
  });
  return data; // { text }
};

// --- Price alerts ---
export const getAlerts = () => adminGet("/alerts");
export const createAlert = (payload) => adminPost("/alerts", payload);
export const deleteAlert = async (id) => (await axios.delete(`${API}/alerts/${id}`, { headers: authHeaders() })).data;

// Streams the assistant reply. Calls onSession(session_id) once, onDelta(text)
// per token chunk, onDone() at the end. Throws on HTTP-level errors (401/429/503).
export const marketAiChatStream = async (message, session_id, { onSession, onDelta, onDone }) => {
  const res = await fetch(`${API}/market-ai/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeaders() },
    body: JSON.stringify({ message, session_id }),
  });
  if (!res.ok) {
    let detail = "The AI assistant is temporarily unavailable.";
    try { detail = (await res.json()).detail || detail; } catch (e) { /* non-JSON */ }
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buffer.indexOf("\n\n")) !== -1) {
      const raw = buffer.slice(0, idx);
      buffer = buffer.slice(idx + 2);
      const line = raw.split("\n").find((l) => l.startsWith("data:"));
      if (!line) continue;
      let ev;
      try { ev = JSON.parse(line.slice(5).trim()); } catch (e) { continue; }
      if (ev.type === "session") onSession?.(ev.session_id);
      else if (ev.type === "delta") onDelta?.(ev.content);
      else if (ev.type === "error") throw new Error(ev.detail || "AI assistant error.");
      else if (ev.type === "done") onDone?.();
    }
  }
};

// --- Profile summary + VIP + social follow (by UID) ---
export const getProfileSummary = () => adminGet("/profile/summary");
export const followUser = (uid) => adminPost("/social/follow", { uid });
export const unfollowUser = (uid) => adminPost("/social/unfollow", { uid });
export const getFollowing = () => adminGet("/social/following");
export const getFollowers = () => adminGet("/social/followers");

// --- Social account linking (bind Google/Apple to the current session) ---
export const linkGoogle = (code) => adminPost("/auth/google/link", { code });
export const unlinkGoogle = async () => (await axios.delete(`${API}/auth/google/unlink`, { headers: authHeaders() })).data;
export const appleStart = async () => (await axios.get(`${API}/auth/apple/start`, { withCredentials: true })).data;
export const linkApple = async (code, state, name) => (await axios.post(`${API}/auth/apple/link`, { code, state, name }, { headers: authHeaders(), withCredentials: true })).data;
export const unlinkApple = async () => (await axios.delete(`${API}/auth/apple/unlink`, { headers: authHeaders() })).data;

// FAQ
export const getFaqs = () => adminGet("/faqs");
export const adminGetFaqs = () => adminGet("/admin/faqs");
export const createFaq = (payload) => adminPost("/admin/faqs", payload);
export const updateFaq = (payload) => adminPost("/admin/faqs/update", payload);
export const reorderFaqs = (payload) => adminPost("/admin/faqs/reorder", payload);

export const getWalletAddresses = async () => {
  const res = await axios.get(`${API}/wallet/addresses`, { headers: authHeaders() });
  return res.data.addresses;
};

export const scanDeposits = async () => {
  const res = await axios.post(`${API}/wallet/scan`, {}, { headers: authHeaders() });
  return res.data;
};

export const getListings = async () => {
  const res = await axios.get(`${API}/listings`);
  return res.data;
};

export const addListing = async (payload) => {
  const res = await axios.post(`${API}/admin/listings`, payload, { headers: authHeaders() });
  return res.data;
};

export const deleteListing = async (id) => {
  const res = await axios.delete(`${API}/admin/listings/${id}`, { headers: authHeaders() });
  return res.data;
};

// Sub-accounts
export const getSubAccounts = () => adminGet("/subaccounts");
export const createSubAccount = (label) => adminPost("/subaccounts", { label });
export const transferSubAccount = (subId, payload) => adminPost(`/subaccounts/${subId}/transfer`, payload);
export const deleteSubAccount = async (subId) => (await axios.delete(`${API}/subaccounts/${subId}`, { headers: authHeaders() })).data;

// Rewards admin
export const adminGetRewardsConfig = () => adminGet("/admin/rewards/config");
export const adminSetRewardsConfig = (tasks) => adminPost("/admin/rewards/config", { tasks });

export const formatUSD = (n, max = 2) =>
  new Intl.NumberFormat("en-US", { minimumFractionDigits: Math.min(2, max), maximumFractionDigits: max }).format(n || 0);

// Order/trade prices: 4 decimals on fiat-like quotes (8 for BTC/BNB quotes or sub-cent prices)
export const formatPrice = (n, quote) => {
  const v = Number(n) || 0;
  const dp = quote === "BTC" || quote === "BNB" || (v && Math.abs(v) < 0.01) ? 8 : 4;
  return new Intl.NumberFormat("en-US", { minimumFractionDigits: dp === 8 ? 2 : 4, maximumFractionDigits: dp }).format(v);
};

export const formatAmount = (n, max = 6) =>
  new Intl.NumberFormat("en-US", { minimumFractionDigits: 0, maximumFractionDigits: max }).format(n || 0);

export const submitListingApplication = async (data) => (await axios.post(`${API}/listing-applications`, data)).data;
export const uploadListingLogo = async (file) => {
  const fd = new FormData(); fd.append("file", file);
  return (await axios.post(`${API}/listing-applications/logo`, fd)).data;
};
export const getListingApplications = async (status) => (await axios.get(`${API}/admin/listing-applications`, { headers: authHeaders(), params: { status } })).data;
export const decideListingApplication = async (payload) => (await axios.post(`${API}/admin/listing-applications/decision`, payload, { headers: authHeaders() })).data;

// Cloudinary uploads are stored as full https URLs; older/self-hosted ones as storage paths.
export const mediaUrl = (path) => (!path ? "" : /^https?:\/\//.test(path) ? path : `${(process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "")}/api/blog/file/${path}`);

export const getStorageCheck = async (verify = false) => (await axios.get(`${API}/admin/storage-check`, { params: { verify }, headers: authHeaders() })).data;
export const topUpInsurance = async (amount, source = "fee_wallet", reason = null) => (await axios.post(`${API}/admin/futures/insurance/topup`, { amount, source, reason }, { headers: authHeaders() })).data;
export const withdrawInsurance = async (amount, reason) => (await axios.post(`${API}/admin/futures/insurance/withdraw`, { amount, reason }, { headers: authHeaders() })).data;
export const getAdminInsurance = async (type) => (await axios.get(`${API}/admin/futures/insurance`, { params: type ? { type } : {}, headers: authHeaders() })).data;
export const getInsuranceFund = async () => (await axios.get(`${API}/insurance-fund`)).data;
export const saveInsuranceSettings = async (min_fund, fee_share_pct = null) => (await axios.put(`${API}/admin/futures/insurance/settings`, { min_fund, fee_share_pct }, { headers: authHeaders() })).data;
export const adjustFuturesMargin = async (id, amount, action) => (await axios.post(`${API}/futures/position/${id}/margin`, { amount, action }, { headers: authHeaders() })).data;
export const getFuturesOHLC = async (symbol, interval) => (await axios.get(`${API}/futures/ohlc`, { params: { symbol, interval } })).data.candles;
export const delistAdminFutures = async (sym) => (await axios.delete(`${API}/admin/futures/${sym}`, { headers: authHeaders() })).data;
export const getPairInfo = async (asset) => (await axios.get(`${API}/pair/${asset}/info`)).data;
export const getPairAudit = async (asset) => (await axios.get(`${API}/pair/${asset}/audit`)).data;
export const getFlowAlerts = async () => (await axios.get(`${API}/flow-alerts`, { headers: authHeaders() })).data.alerts || [];
export const addFlowAlert = async (asset, quote) => (await axios.post(`${API}/flow-alerts`, { asset, quote }, { headers: authHeaders() })).data;
export const removeFlowAlert = async (asset, quote) => (await axios.delete(`${API}/flow-alerts/${asset}/${quote}`, { headers: authHeaders() })).data;
export const getPairTags = async (asset) => (await axios.get(`${API}/pair/${asset}/tags`)).data;
export const getPairAnalysis = async (asset, quote = "USDT", window = "1d") => (await axios.get(`${API}/pair/${asset}/analysis`, { params: { quote, window } })).data;
export const getPairAiSummary = async (asset, quote = "USDT") => (await axios.get(`${API}/pair/${asset}/ai-summary`, { params: { quote }, headers: authHeaders() })).data;
export const adminGetTokenTags = async () => (await axios.get(`${API}/admin/token-tags`, { headers: authHeaders() })).data;
export const adminSaveTokenTags = async (tags) => (await axios.put(`${API}/admin/token-tags`, { tags }, { headers: authHeaders() })).data;
export const getPairData = async (asset, quote = "USDT") => (await axios.get(`${API}/pair/${asset}/data`, { params: { quote } })).data;
export const savePairProfile = async (asset, body) => (await axios.put(`${API}/admin/listings/${asset}/profile`, body, { headers: authHeaders() })).data;
export const getSquare = async (asset, sort = "new") => (await axios.get(`${API}/square/${asset}`, { params: { sort }, headers: authHeaders() })).data;
export const postSquare = async (asset, text, sentiment) => (await axios.post(`${API}/square/${asset}`, { text, sentiment }, { headers: authHeaders() })).data;
export const likeSquare = async (id) => (await axios.post(`${API}/square/post/${id}/like`, {}, { headers: authHeaders() })).data;
export const deleteSquare = async (id) => (await axios.delete(`${API}/square/post/${id}`, { headers: authHeaders() })).data;
export const getPairFuturesData = async (asset) => (await axios.get(`${API}/pair/${asset}/futures-data`)).data;
export const getLeaderboard = async (period) => (await axios.get(`${API}/futures/leaderboard`, { params: { period } })).data;
export const getMyLeaderboard = async (period) => (await axios.get(`${API}/futures/leaderboard/me`, { params: { period }, headers: authHeaders() })).data;
export const setLeaderboardProfile = async (body) => (await axios.put(`${API}/futures/leaderboard/profile`, body, { headers: authHeaders() })).data;
export const getAdminCoinDetails = async () => (await axios.get(`${API}/admin/coin-details`, { headers: authHeaders() })).data.coins;
export const getServerHealth = async () => (await axios.get(`${API}/admin/server-health`, { headers: authHeaders() })).data;
export const getBotArchive = async () => (await axios.get(`${API}/admin/bot-trade-archive`, { headers: authHeaders() })).data;
export const getHomeSettings = async () => (await axios.get(`${API}/admin/home-settings`, { headers: authHeaders() })).data;
export const getContactMessages = async () => (await axios.get(`${API}/admin/contact-messages`, { headers: authHeaders() })).data;
export const getMarginTags = async () => (await axios.get(`${API}/markets/margin-tags`)).data;
export const adminGetMarginTags = async () => (await axios.get(`${API}/admin/margin-tags`, { headers: authHeaders() })).data;
export const adminSaveMarginTags = async (body) => (await axios.put(`${API}/admin/margin-tags`, body, { headers: authHeaders() })).data;
export const markContactRead = async (id) => (await axios.put(`${API}/admin/contact-messages/${id}/read`, {}, { headers: authHeaders() })).data;
export const saveHomeSettings = async (body) => (await axios.put(`${API}/admin/home-settings`, body, { headers: authHeaders() })).data;
export const getHomeBanners = async () => (await axios.get(`${API}/admin/home-banners`, { headers: authHeaders() })).data.banners;
export const saveHomeBanner = async (b) => (await axios.post(`${API}/admin/home-banners`, b, { headers: authHeaders() })).data;
export const deleteHomeBanner = async (id) => (await axios.delete(`${API}/admin/home-banners/${id}`, { headers: authHeaders() })).data;
export const reorderHomeBanners = async (ids) => (await axios.post(`${API}/admin/home-banners/reorder`, { ids }, { headers: authHeaders() })).data;
export const getHomeCardImages = async () => (await axios.get(`${API}/admin/home-card-images`, { headers: authHeaders() })).data.coins;
export const setHomeCardImage = async (symbol, image) => (await axios.put(`${API}/admin/home-card-images`, { symbol, image }, { headers: authHeaders() })).data;
export const runBotArchive = async () => (await axios.post(`${API}/admin/bot-trade-archive/run`, {}, { headers: authHeaders() })).data;
export const listBotArchive = async (page, asset) => (await axios.get(`${API}/admin/bot-trade-archive/trades`, { params: { page, asset }, headers: authHeaders() })).data;
export const exportBotArchive = async (asset) => (await axios.get(`${API}/admin/bot-trade-archive/export`, { params: { asset }, headers: authHeaders(), responseType: "blob" })).data;
